import { createAction } from 'typesafe-actions';

export const setLastResult = createAction('@result/SET_LAST_RESULT')();
export const resetLastResult = createAction('@result/RESET_LAST_RESULT')();
